<template>
  <div :id="'myChart'+index" :style="{width: '100%', height: '100px'}"></div>
</template>
<script>
import { Line } from "vue-chartjs";

export default {
  name: "LineChart",
  extends: Line,
  props: ["labels", "label", "data", "options", "index"],
  mounted() {
    /* this.drawLine(); */
  },
  watch:{
    data:function(){
      this.drawLine()
    }
  },
  methods: {
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(
        document.getElementById("myChart" + this.index)
      );
      // 绘制图表
      myChart.setOption({
        title: { show: false },
        tooltip: {
          show:false,
          trigger: "axis",
          position: function(pt) {
            return [pt[0], "10%"];
          },
          axisPointer: {
            lineStyle: {
              width: 1,
              color: "#0000001a"
            }
          },
          backgroundColor: "#fff",
          textStyle: {
            color: "#F7B500"
          },
          formatter: function(params) {
            var res = "<div><div>"+params[0].name+"</div><div>"+params[0].data+"</div></div>";
            return res;
          }
        },
        grid:{
          top:10,
          bottom:20,
          left:31,
          right:10,
        },
        xAxis: {
          data: this.labels,
          axisPointer: {
            show: false,
          },
            axisLine:{
              show:false
            },
             axisTick:{
               show:false
             },
            splitLine:{
              show:false
            },
            axisLabel:{
              interval:7,
              fontSize:10,
              showMaxLabel:true,
              color:'rgba(0, 0, 0, 0.3)'
            }
        },
        yAxis: {
          splitNumber:3,
            axisLine:{
              show:false
            },
             axisTick:{
               show:false
             },
            splitLine:{
              show:false
            },
            axisLabel: {
              fontSize:10,
              interval:5,
              showMinLabel:false,
              color:'rgba(0, 0, 0, 0.3)',
              formatter: function (value,index) {
                if (value > 1000) {
                  return value / 1000 + 'k';
                } else {
                  return value
                }
              }
            }
        },
        series: [
          {
            name: this.label,
            type: "line",
            symbol: "none",
            smooth:true,
            itemStyle: {
              normal: {
                /* 线条颜色 */
                lineStyle: {
                  color: "#000",
                  width:1.2,
                }
              }
            },
            data: this.data
          }
        ]
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/TxLineChart.vue